import { render, staticRenderFns } from "./estadoLeechero.vue?vue&type=template&id=e5554c7c&"
import script from "./estadoLeechero.vue?vue&type=script&lang=js&"
export * from "./estadoLeechero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports